
import req from './request'

const DEFAULT_ENDPOINTS = {
    cars:'/iron-park/cars',
    detail: '/iron-park/cars/detail',
    reference: '/iron-park/cars/reference',
    modelsByBran: '/iron-park/cars/models-by-brand',
    carsEdit: '/iron-park/cars/edit',
    mileages: '/iron-park/mileages',
    files: '/iron-park/files',
    history: '/iron-park/reports/history',
    orders: '/iron-park/reports/orders',
    transactions: '/iron-park/reports/transactions',
    drivers: '/iron-park/drivers',
    driversReference: '/iron-park/drivers/reference',
    driverDetail: '/iron-park/drivers/detail',
    driversSend: '/iron-park/drivers/send',
    external: '/iron-park/external',
    //carsAssign: '/iron-park/cars/assign',
    carsAssign: '/iron-park/park/car/management/assign',
    //carsUnassign: '/iron-park/cars/unassign',
    carsUnassign: '/iron-park/park/car/management/unassign',
    checkAccess: '/iron-park/cars/check-access',
    parksByCompany: '/iron-park/drivers/parks-by-company',
    reportcars: '/iron-park/summary/report/cars',
    reportHistory: '/iron-park/summary/report/history',
    reportTransactions: '/iron-park/summary/report/transactions',
    reportOrders: '/iron-park/summary/report/orders',
    driverCarsList: '/iron-park/cars/driver-cars-list',
    cooperation:'/iron-park/agreement-cooperation',
    cooperationReference:'/iron-park/agreement-cooperation/reference',
    cooperationTextByLanguage:'/iron-park/agreement-cooperation/text-by-language',
    retrieveDriverInfo: '/iron-park/cars/retrieve-driver-info',
    agreementsList: '/iron-park/agreements/list',
    agreementsAvailableLanguages: '/iron-park/agreements/available-languages',
    agreementsGenerate: '/iron-park/agreements/generate',
    agreementsGetFile:'/iron-park/agreements/get-file',
    agreementsSignByDriver:'/iron-park/agreements/sign-by-driver',
    agreementsReference: '/iron-park/agreements/reference',
    signByDnterprise: '/iron-park/agreements/sign-by-enterprise',
    managementList: '/iron-park/park/car/management/list',
    managementReference: '/iron-park/park/car/management/reference',
    paymentsDebtors:'/iron-park/payments/debtors',
    paymentsPay: '/iron-park/payments/pay',
    paymentsTransactions:'/iron-park/payments/transactions',
    managementHistory: '/iron-park/park/car/management/history',
    finesList:'/iron-park/cars/fines/list',
    getSignDocument: '/iron-park/agreements/get-sign-document',
    mutualSettlementList:'/iron-park/mutual-settlement/default/list',
    mutualSettlementListDetails:'/iron-park/mutual-settlement/default/details',
    mutualSettlementView: '/iron-park/mutual-settlement/default/view',
    mutualSettlementReceipt:'/iron-park/mutual-settlement/receipt',
    mutualSettlementConfirm: '/iron-park/mutual-settlement/default/confirm',
    retrieveWorkRules: '/iron-park/drivers/retrieve-work-rules',
    rents:'/iron-park/park/car/management/rents',
    details: '/iron-park/balances/details',
    balancesList: '/iron-park/balances/list',
    managementDetail: '/iron-park/park/car/management/detail',
    managementUpdate: '/iron-park/park/car/management/update',
    retrieveDriverSearch: '/iron-park/park/car/management/retrieve-driver-search',
    balancesCommissions: '/iron-park/balances/commissions',
    balancesWithdraw: '/iron-park/balances/withdraw',
}

export default {
    cars(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.cars, param)
    },
    detail(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.detail, param)
    },
    reference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    modelsByBran(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.modelsByBran, param)
    },
    carsEdit(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.carsEdit, param)
    },
    mileages(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mileages, param)
    },
    files(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.files, param)
    },
    history(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.history, param)
    },
    orders(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.orders, param)
    },
    transactions(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.transactions, param)
    },
    drivers(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.drivers, param)
    },
    driversReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversReference, param)
    },
    driverDetail(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driverDetail, param)
    },
    driversSend(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driversSend, param)
    },
    external(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.external, param)
    },
    carsAssign(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.carsAssign, param)
    },
    carsUnassign(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.carsUnassign, param)
    },
    checkAccess(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.checkAccess, param)
    },
    parksByCompany(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parksByCompany, param)
    },
    reportcars(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportcars, param)
    },
    reportHistory(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportHistory, param)
    },
    reportTransactions(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportTransactions, param)
    },
    reportOrders(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reportOrders, param)
    },
    driverCarsList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.driverCarsList, param)
    },
    cooperation(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.cooperation, param)
    },
    cooperationReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.cooperationReference, param)
    },
    cooperationTextByLanguage(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.cooperationTextByLanguage, param)
    },
    retrieveDriverInfo(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.retrieveDriverInfo, param)
    },
    agreementsList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsList, param)
    },
    agreementsAvailableLanguages(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsAvailableLanguages, param)
    },
    agreementsGenerate(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsGenerate, param)
    },
    agreementsGetFile(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsGetFile, param)
    },
    agreementsSignByDriver(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsSignByDriver, param)
    },
    agreementsReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.agreementsReference, param)
    },
    signByDnterprise(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.signByDnterprise, param)
    },
    managementList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.managementList, param)
    },
    managementReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.managementReference, param)
    },
    paymentsDebtors(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paymentsDebtors, param)
    },
    paymentsPay(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paymentsPay, param)
    },
    paymentsTransactions(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.paymentsTransactions, param)
    },
    managementHistory(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.managementHistory, param)
    },
    finesList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.finesList, param)
    },
    getSignDocument(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getSignDocument, param)
    },
    mutualSettlementList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mutualSettlementList, param)
    },
    mutualSettlementListDetails(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mutualSettlementListDetails, param)
    },
    mutualSettlementView(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mutualSettlementView, param)
    },
    mutualSettlementReceipt(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mutualSettlementReceipt, param)
    },
    mutualSettlementConfirm(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.mutualSettlementConfirm, param)
    },
    retrieveWorkRules(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.retrieveWorkRules, param)
    },
    rents(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.rents, param)
    },
    details(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.details, param)
    },
    balancesList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.balancesList, param)
    },
    managementDetail(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.managementDetail, param)
    },
    managementUpdate(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.managementUpdate, param)
    },
    retrieveDriverSearch(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.retrieveDriverSearch, param)
    },
    balancesCommissions(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.balancesCommissions, param)
    },
    balancesWithdraw(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.balancesWithdraw, param)
    },
}